import Link from "@/src/common/components/Link"
import ArrowTopRight from "@/src/sb/components/icon/ArrowTopRight"
import { getIntelligenceDestination } from "@/src/sb/core/utils/helpers"
import { format } from "date-fns"

import { Topic } from "../../business-layer/types"

export type IntelligenceProps = {
  id: number
  title: string
  slug: string
  date?: string
  type?: string
  mainTopic: Topic | null
  bucketSlug?: string
  groupSlug?: string
  countryRiskSlug?: string
  countrySlug?: string
  tabSlug?: string
  tag?: string
}

type RelatedIntelligenceProps = {
  onClickAction?: (report: IntelligenceProps) => void
  intelligence: Array<IntelligenceProps>
  heading?: string
  moreHref: string
  /**
   * Type of intelligence
   */
  type?: "datasets" | "reports"
}

const getIntelligenceUrl = (
  intelligence: IntelligenceProps,
  type: "datasets" | "reports" = "reports"
): string => {
  return getIntelligenceDestination(type === "reports", intelligence)
}

const RelatedIntelligence = ({
  intelligence,
  onClickAction,
  heading,
  moreHref,
  type
}: RelatedIntelligenceProps) => (
  <section className="bg-stears_white dark:bg-[#0E0F10] font-jakarta border-[0.5px] dark:border-gray-600 h-full relative overflow-auto no-scrollbar">
    <section
      className={
        "flex justify-between items-center gap-4 w-full px-5 py-3 border-b-[0.5px] dark:border-gray-600 sticky top-0 bg-inherit"
      }
    >
      {heading ? <h4 className="text-[14px] font-[500]">{heading}</h4> : null}

      <Link
        className={
          "w-6 h-6 bg-gray-200 dark:bg-gray-800 flex justify-center items-center rounded-[4px]"
        }
        href={moreHref}
      >
        <ArrowTopRight size={16} />
      </Link>
    </section>

    <ul>
      {intelligence.map((intelligenceItem) => (
        <li
          key={intelligenceItem.id}
          className="first:border-0 border-t-[0.5px] dark:border-gray-600 border-gray-10"
        >
          <a
            className="flex justify-between gap-4 items-center px-5 py-2 w-full !no-underline"
            title={intelligenceItem.title}
            href={getIntelligenceUrl(intelligenceItem, type)}
            onClick={() => onClickAction?.(intelligenceItem)}
          >
            <h5 className="text-xs line-clamp-1 font-normal hover:underline">
              {intelligenceItem.title}
            </h5>

            {intelligenceItem.date ? (
              <span className="text-[#4B5563] text-[10px] font-light dark:text-gray-400 shrink-0 decoration-transparent">
                {format(new Date(intelligenceItem.date), "MMM dd, yyy")}
              </span>
            ) : null}

            {intelligenceItem.tag ? (
              <span className="bg-[#1A1D21] text-nowrap text-white text-[10px] py-[2px] px-[8px] decoration-transparent">
                {intelligenceItem.tag}
              </span>
            ) : null}
          </a>
        </li>
      ))}
    </ul>
  </section>
)

export default RelatedIntelligence
